// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root___RIS0","right":"Footer_right__3LAjQ","buttons":"Footer_buttons__1tpKk"};